module.exports = __webpack_public_path__ + "img/cabin_5.a9696de1.jpg";